import PeugeotIcon from 'vectors/brands/peugeot.svg';
import OpelIcon from 'vectors/brands/opel.svg';
import VolkswagenIcon from 'vectors/brands/volkswagen.svg';
import CitroenIcon from 'vectors/brands/citroen.svg';
import MercedesIcon from 'vectors/brands/mercedes.svg';
import ToyotaIcon from 'vectors/brands/toyota.svg';
import NissanIcon from 'vectors/brands/nissan.svg';
import FiatIcon from 'vectors/brands/fiat.svg';
import FordIcon from 'vectors/brands/ford.svg';
import IvecoIcon from 'vectors/brands/iveco.svg';
import ManIcon from 'vectors/brands/man.svg';
import RenaultIcon from 'vectors/brands/renault.svg';
import AldIcon from 'vectors/partners/ald.svg';
import AlphabetIcon from 'vectors/partners/alphabet.svg';
import AthlonIcon from 'vectors/partners/athlon.svg';
import BeequipIcon from 'vectors/partners/beequip.svg';
import LeasePlanIcon from 'vectors/partners/leaseplan.svg';
import PonIcon from 'vectors/partners/pon.svg';

export const offerPartners = {
  carPartner: [CitroenIcon, FiatIcon, FordIcon, IvecoIcon, ManIcon, MercedesIcon,
    NissanIcon, OpelIcon, PeugeotIcon, RenaultIcon, VolkswagenIcon, ToyotaIcon],
  leasePartner: [AldIcon, AlphabetIcon, AthlonIcon, BeequipIcon,
    LeasePlanIcon, PonIcon],
};
